import React, { useState, useEffect } from 'react';
import { Chart } from "react-google-charts";
import Dropdown from 'react-bootstrap/Dropdown'; // Import Dropdown from react-bootstrap

function AlertTradeResultsChart(props) {

    const [trades, setTrades] = useState([]);
    const [sortOption, setSortOption] = useState("date"); // New state for sorting

    useEffect(() => {
        (async function () {
            if (props.trades) {
                setTrades(props.trades);
            }
        })();
    }, [props.trades]);

    function handleSortChange(option) {
        setSortOption(option); // Update sort option
    }

    function getChartData() {
        if (trades && trades.length) {
            let ret = [];
            if (props.showDrawdown)
                ret.push(["Trade", "Trade Max Drawdown"])
            else
                ret.push(["Trade", "Trade Profit"])
            let counter = 0;
            let max = null;
            let min = 0;

            const sortedTrades = [...trades].sort((a, b) => {
                if (sortOption === "profit") {
                    return b.profitPercentage - a.profitPercentage;
                } else if (sortOption === "date") {
                    return new Date(a.purchase_date) - new Date(b.purchase_date);
                }
                return 0;
            });

            sortedTrades.forEach(t => {
                if (t.sell_date) {
                    ++counter;
                    let value = t.profitPercentage / 100;
                    if (props.showDrawdown)
                        value = t.maxDrawdown / 100;
                    ret.push([counter, value])

                    if (max === null || value > max)
                        max = value;
                    if (value < min)
                        min = value;
                }
            })
            return [ret, min, max];
        } else {
            return null;
        }
    }

    let profitChartData = getChartData();
    let profitChartOptions = profitChartData ? {
        legend: { position: 'none' },
        hAxis: {
            title: sortOption === "date" ? "Trade Number" : "Profit %"
        },
        vAxis: {
            format: '#%',
            viewWindow: {
                max: profitChartData[2] * 1.1,
                min: profitChartData[1] * 1.1
            },
        },
    } : null;

    return (
        <div>
            {/* Dropdown for sorting */}
            <br></br>
            <div style={{ marginBottom: "10px" }}>
                <Dropdown onSelect={handleSortChange}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        Sort Trades By: {sortOption === "date" ? "Date" : "Profit"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item eventKey="date">Date</Dropdown.Item>
                        <Dropdown.Item eventKey="profit">Profit</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            {
                trades && trades.length && profitChartData ?
                    <Chart
                        chartType="ColumnChart"
                        width={"100%"}
                        data={profitChartData[0]}
                        options={profitChartOptions}
                        chartPackages={["corechart", "controls"]}
                    />
                    :
                    null
            }
        </div >);
}

export default AlertTradeResultsChart;